export const SETTITLE = "set_title";
export const ADDUSER = "add_user";
export const INCREMENTPROCESADO = "increment_procesado";
export const INCREMENTTOTAL = "increment_total";